import { Fragment } from "react";
import { QuestionTitle } from "components/atoms/Text";

const QuestionBox = ({ question, children, classNames }) => {
    return (
        <Fragment>
            <QuestionTitle classNames={classNames}>{question}</QuestionTitle>
            <div className="mt-4 phone:mt-3">
                {children}
            </div>
        </Fragment>
    );
};

export default QuestionBox;